import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareDotedBehindSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareDotedBehindSquare"><Path d="M11.75 2H8V5.75H9.5V3.5H11.75V2Z" fill="currentColor"/><Path d="M16.75 2H13.25V3.5H16.75V2Z" fill="currentColor"/><Path d="M22 2H18.25V3.5H20.5V5.75H22V2Z" fill="currentColor"/><Path d="M9.5 8V7.25H8V8H2V22H16V16H16.75V14.5H16V8H9.5Z" fill="currentColor"/><Path d="M22 10.75V7.25H20.5V10.75H22Z" fill="currentColor"/><Path d="M22 16V12.25H20.5V14.5H18.25V16H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareDotedBehindSquare;
